module.exports = __webpack_public_path__ + "static/media/Pic-0513.458192ca.jpg";